<template>
  <div>
    <div class="table-list mt20">
      <div class="spec-head">
        <div class="sp-col">姓名</div>
        <div class="sp-col">手机号</div>
        <div class="sp-col">性别</div>
        <div class="sp-col">与报名者关系</div>
        <div class="sp-col">操作</div>
      </div>
      <div class="spec-item" v-for="(item, idx) in form.carryPeopleList" :key="idx">
        <el-form-item class="sp-col" :prop="`carryPeopleList[${idx}].realName`" label-width="0" :rules="{required: true,message: '请选择',trigger: 'change'}">
          <el-input v-model="item.realName" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item class="sp-col" :prop="`carryPeopleList[${idx}].mobile`" label-width="0" :rules="{required: true,message: '请选择',trigger: 'change',}">
          <el-input v-model="item.mobile" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item class="sp-col" :prop="`carryPeopleList[${idx}].sex`" label-width="0" :rules="{required: true,message: '请填写',trigger: 'change',}">
          <el-select v-model="item.sex" placeholder="请选择">
            <el-option label="男" :value="1"></el-option>
            <el-option label="女" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="sp-col" :prop="`carryPeopleList[${idx}].relationship`" label-width="0" :rules="{required: true,message: '请填写',trigger: 'change',}">
          <el-input v-model="item.relationship" placeholder="请输入与报名者关系" />
        </el-form-item>
        <div class="sp-col oper-icon">
          <i class="el-icon-minus" @click="handleDeleteItem(idx)"></i>
          <i class="el-icon-plus" @click="handleAddItem"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageUpload from "@/components/ImageUpload";
export default {
  props: ['form'],
  components: { ImageUpload },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    handleDeleteItem(index) {
      this.form.carryPeopleList.splice(index, 1)

    },
    handleAddItem() {
      this.form.carryPeopleList.push({ realName: '', mobile: '', sex: '', relationship: '' })

    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item--small.el-form-item.w60 {
  width: 70%;
  display: inline-block;
  vertical-align: top;
  input {
    width: 40%;
  }
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
.flexs {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .oper {
    width: 300px;
    display: inline-block;
    font-size: 16px;
    span {
      padding-left: 20px;
      cursor: pointer;
    }
    .del {
      color: #e73f3f;
      padding-left: 20px;
    }
    .add {
      color: #5dbde7;
    }
  }
}
.table-list {
  border: 1px solid #e4e4e4;
  // margin: 0 35px 20px 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.oper-icon {
  i {
    cursor: pointer;
    font-size: 22px;
    color: #465c99;
    &:nth-child(1) {
      padding-right: 5px;
    }
  }
}
</style>